import { Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { patchMessage } from '../../redux/actions/conversationActions';
import { selectConversations, setIsLoading } from '../../redux/reducers/conversationReducer';
import { AppDispatch } from '../../redux/store';
import { MCPApprovalRequest } from '../../Types/conversation';
import { useChat } from '../Providers/ChatProvider';

const ChatMCPApprovalRequest = ({
  messageId,
  conversationId,
  mcpApprovalRequests,
}: {
  messageId: string;
  conversationId: string;
  mcpApprovalRequests: MCPApprovalRequest[];
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading } = useSelector(selectConversations);
  const { replaceCurrentMessage, submitMessage } = useChat();

  const approveRequest = useCallback(async () => {
    dispatch(setIsLoading(true));
    const action = await dispatch(
      patchMessage({
        messageId: messageId,
        updatedFields: {
          mcpApprovalRequests: mcpApprovalRequests.map(
            (request) => ({ ...request, approved: true } as MCPApprovalRequest)
          ),
        },
      })
    );

    if (patchMessage.fulfilled.match(action)) {
      replaceCurrentMessage(action.payload);
    }

    dispatch(setIsLoading(true));
    submitMessage('', [], conversationId);
  }, [
    dispatch,
    messageId,
    mcpApprovalRequests,
    replaceCurrentMessage,
    submitMessage,
    conversationId,
  ]);

  const declineRequest = useCallback(async () => {
    const action = await dispatch(
      patchMessage({
        messageId: messageId,
        updatedFields: {
          mcpApprovalRequests: mcpApprovalRequests.map(
            (request) => ({ ...request, approved: false } as MCPApprovalRequest)
          ),
        },
      })
    );

    if (patchMessage.fulfilled.match(action)) {
      replaceCurrentMessage(action.payload);
    }
  }, [dispatch, messageId, mcpApprovalRequests, replaceCurrentMessage]);

  if (mcpApprovalRequests[0].approved !== undefined && mcpApprovalRequests[0].approved !== null) {
    return (
      <Typography variant="caption2">
        {`The model was ${
          mcpApprovalRequests[0].approved ? 'approved' : 'denied'
        } to utilize the MCP Server ${
          mcpApprovalRequests[0].requestObject.server_label
        } to execute the method
      "${mcpApprovalRequests[0].requestObject.name}" with the following arguments: ${
          mcpApprovalRequests[0].requestObject.arguments
        }.`}
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="caption2">
        {`The model would like to utilize the MCP Server ${mcpApprovalRequests[0].requestObject.server_label} to execute the method
      "${mcpApprovalRequests[0].requestObject.name}" with the following arguments: ${mcpApprovalRequests[0].requestObject.arguments}.`}
      </Typography>
      <div>
        <Button onClick={approveRequest} disabled={isLoading}>
          Approve
        </Button>
        <Button onClick={declineRequest} disabled={isLoading}>
          Deny
        </Button>
      </div>
    </>
  );
};

export default ChatMCPApprovalRequest;
